import React, { useState, useRef, useEffect } from 'react';
import styles from '../../Dashboard.module.scss';
//charts
import { Bar } from 'react-chartjs-2';
import { getColumnName } from '../../Utils/dashboardUtils';
//Tr
import { useTranslation } from 'react-i18next';
export const BarChart: React.FC<any> = ({ data, label, periodFilter }) => {
  const { t } = useTranslation();

  const [width, setWidth] = useState(0);
  const elementRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    elementRef.current && setWidth(elementRef.current.clientWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getMaxTicksLimit = () => {
    if (width < 600) {
      return 5;
    }
    if (width > 940) {
      return 20;
    } else return 10;
  };
  const emptyChart = {
    labels: [],
    datasets: [
      {
        stack: 'stack',
        label: label,
        data: [],
        backgroundColor: '#27de81',
        borderRadius: 2,
      },
    ],
  };
  const [chartData, setChartData] = useState(emptyChart);
  const formatChartData = (data: any) => {
    const labels = data.map((element: any) =>
      getColumnName(element.date, periodFilter, t),
    );
    const dataPoints = data.map((element: any) => element.value);
    const chartData = {
      labels: labels,
      datasets: [
        {
          stack: 'stack',
          label: label,
          data: dataPoints,
          backgroundColor: '#27de81',
          borderRadius: 2,
        },
      ],
    };
    setChartData(chartData);
  };
  React.useEffect(() => {
    !data ? setChartData(emptyChart) : formatChartData(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const options = {
    animation: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: 'point',
        intersect: false,
      },
    },

    // barThickness: 30,
    maxBarThickness: 30,
    responsive: true,
    maintainAspectRatio: false,

    scales: {
      x: {
        offset: true,
        stacked: false,
        grid: {
          display: false,
        },
        ticks: {
          maxTicksLimit: getMaxTicksLimit(),
          maxRotation: 0,
          minRotation: 0,
        },
      },
      y: {
        stacked: false,
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 10,
          stepSize: 1,
        },
      },
    },
  };

  return (
    <div ref={elementRef}>
      <Bar
        // @ts-ignore
        type="bar"
        data={chartData}
        // @ts-ignore
        options={options}
        className={styles.stackedChart}
      />
    </div>
  );
};
